<template>
  <label class="basic-radio"
         :id="$props.id"
         :class="[radioClasses, {'invalid': $props.invalid}, {'disabled': isDisabled}]">
    <input type="radio"
           :id="radioId"
           :name="radioName"
           ref="input"
           :value="value"
           :checked="checked"
           :disabled="disabled"
           @change="updateValue">
    <span class="checkbox-box"></span>
    <span class="checkbox-label">
      <slot>{{$props.label}}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'base-radio',
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    value: {},
    modelValue: {
      default: undefined
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: String,
    name: String,
    label: String,
    invalid: Boolean,
    disabled: {
      type: [Boolean, String],
      default: false
    },
    variant: {
      type: String,
      default: 'red',
      validator: (value) => {
        const variants = ['red', 'green']
        return variants.includes(value)
      }
    },
    size: {
      type: String,
      default: 'normal',
      validator: (value) => {
        const sizes = ['small', 'normal']
        return sizes.includes(value)
      }
    },
    verticalAlign: {
      type: String,
      default: 'start',
      validator: (value) => {
        const allowedAlignments = ['start', 'center', 'end']
        return allowedAlignments.includes(value)
      }
    },
    position: {
      type: String,
      default: 'left',
      validator: (value) => {
        const allowedPositions = ['left', 'right']
        return allowedPositions.includes(value)
      }
    }
  },
  computed: {
    currentValue: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    radioId () {
      return this.$props.id || `radio-${this._uid}`
    },
    radioName () {
      return this.$props.name || `radio-${this._uid}`
    },
    radioClasses () {
      return {
        [`variant-${this.$props.variant}`]: this.$props.variant,
        [`size-${this.$props.size}`]: this.$props.size,
        [`position-${this.$props.position}`]: this.$props.position,
        [`valign-${this.$props.verticalAlign}`]: this.$props.verticalAlign
      }
    },
    isDisabled () {
      if (typeof this.$props.disabled === 'string') {
        return this.$props.disabled === 'disabled'
      }
      return this.$props.disabled
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.$props.value)
    },
    focusIn () {
      if (this.$refs.input) this.$refs.input.focus()
    }
  },
  watch: {
    modelValue (newVal) {
      if (newVal === this.value) {
        this.$nextTick(() => {
          this.$refs.input.checked = true
        })
      } else {
        this.$refs.input.checked = false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.modelValue === this.value || this.checked) {
        this.$refs.input.checked = true
        this.updateValue()
      }
    })
  }
}
</script>

<style scoped lang="scss" src="./base-comp-styles/base-checkbox.scss"></style>
